import { Prisma } from "@prisma/client";
import { FunctionComponent } from "react";
import RadioButton from "./RadioButton";

export interface RadioButtonGroupType {
  id: string;
  active: any;
  label: string;
  error?: boolean;
  errorText?: String;
  setValue: Function;
  showLabel?: boolean;
  properties: { options: Prisma.JsonValue };
}

const RadioButtonGroup: FunctionComponent<RadioButtonGroupType> = ({
  id,
  setValue,
  active,
  showLabel,
  error,
  errorText,
  label,
  properties,
}) => {
  const options: Array<{ value: any; label: string }> = properties.options
    ? JSON.parse(JSON.stringify(properties.options))
    : [];
  const radioButtons = options.map((option) => {
    return (
      <div
        className={`px-1 py-1 ${
          options.length % 3 === 0 ? "w-full md:w-1/3" : "w-1/2"
        } lg:px-2 lg:py-2`}
        key={option.value}
      >
        <RadioButton
          {...option}
          isActive={option.value === active}
          setValue={() => setValue(option.value, id)}
        />
      </div>
    );
  });
  return (
    <div>
      <p className={`text-sm mb-2 ${!label || !showLabel ? "hidden" : null}`}>
        {label}
      </p>
      <div className="flex flex-wrap items-stretch -mx-1 -my-1 lg:-my-2 lg:-mx-2">
        {radioButtons}
      </div>
      {error ? <p className="mt-2 text-xs text-red-500">{errorText}</p> : null}
    </div>
  );
};

export default RadioButtonGroup;
